import { UserIcon } from '@heroicons/react/24/solid';
import React from 'react';
import TransactionChart from './TransactionChart';
import TransactionReport from './TransactionReport';

function Dashboard(props) {
  return (
    <div className='w-full bg-white rounded-2xl flex flex-col px-6 py-6'>
      <p className='text-lg my-4 text-left text-gray-800 font-semibold'>Dashboard</p>

      {/* dashboard card */}
      <div className='grid grid-cols-2 lg:grid-cols-4 gap-2 w-full '>


        {/* Lapang Terlaris  */}
        <div className='relative flex flex-col gap-2 py-3 px-4 overflow-hidden rounded-lg bg-[#fefffa] border border-[#e6efc8]'>
          <p className='text-gray-800 text-[12px] font-semibold'>Lapang Terlaris </p>
          <p className='text-gray-800 flex-grow flex items-center text-[16px] font-semibold'> Colloseum Arena </p>
          <div className=''>
            <p className='text-gray-800 text-[10px]'>Jumlah Sesi </p>
            <p className='text-gray-800 text-[14px] font-semibold'>25 </p>
          </div>
          <div className='absolute flex justify-center items-center -bottom-3 -right-3 w-14 h-14 bg-[#e6efc8] rounded-lg'>
            <img src='/ic_field_dashboard.png' className='w-[28px] h-[28px] -translate-x-[3px] -translate-y-[3px]' />
          </div>

        </div>


        {/* paket terlaris  */}
        <div className='relative flex flex-col gap-2 py-3 px-4 overflow-hidden rounded-lg bg-[#fdf9fb] border border-[#efc8da]'>
          <p className='text-gray-800 text-[12px] font-semibold'> Paket Terlaris</p>


          <p className='text-gray-800 flex-grow flex items-center text-[18px] font-semibold'>LT++</p>

          <div>
            <p className='text-gray-800 text-[10px]'>dalam </p>
            <p className='text-gray-800 text-[12px] font-semibold'>24 Sesi Booking</p>
          </div>

          <div className='absolute flex justify-center items-center -bottom-3 -right-3 w-14 h-14 bg-[#efc8da] rounded-lg'>
            <img src='/ic_task_dashboard.png' className='w-[28px] text-[#a94975] -translate-x-[3px] -translate-y-[4px]' />
          </div>

        </div>

        {/* User Terbaik  */}
        <div className='relative flex flex-col gap-2 py-3 px-4 overflow-hidden rounded-lg bg-[#fcfbf8] border border-[#efe7c8]'>
          <p className='text-gray-800 text-[12px]  font-semibold'> User Terbaik</p>

          <div className='flex justify-between flex-grow items-center '>
            <div>
              <p className='text-gray-800 text-[10px]'>Total Transaksi </p>
              <p className='text-gray-800 text-[14px] font-semibold'>Rp5.000.000 </p>
            </div>

            <div>
              <p className='text-gray-800 text-[10px]'>Jml Sesi </p>
              <p className='text-gray-800 text-[14px] font-semibold'>17</p>
            </div>
          </div>

          <p className='text-gray-800 text-[14px] font-semibold'>Mawar</p>

          <div className='absolute flex justify-center items-center -bottom-3 -right-3 w-14 h-14 bg-[#efe7c8] rounded-lg'>
            <img src='/ic_user_dashboard.png' className='w-[30px] text-[#b08631] -translate-x-[2px] -translate-y-[4px]' />
          </div>

        </div>

        {/* Sesi Terlaris  */}
        <div className='relative flex flex-col gap-2 py-3 px-4 overflow-hidden rounded-lg bg-[#f8fdff] border border-[#c8e5ef]'>
          <p className='text-gray-800 text-[12px] font-semibold'> Sesi Booking Terlaris</p>


          <p className='text-gray-800 flex-grow flex items-center text-[18px] font-semibold'>18:00 - 20:00</p>

          <div>
            <p className='text-gray-800 text-[10px]'>dalam </p>
            <p className='text-gray-800 text-[12px] font-semibold'>2 Sesi Booking</p>
          </div>

          <div className='absolute flex justify-center items-center -bottom-3 -right-3 w-14 h-14 bg-[#c8e5ef] rounded-lg'>
            <img src='/ic_clock_dashboard.png' className='w-[32px] text-[#3593a6] -translate-x-[4px] -translate-y-[4px]' />
          </div>

        </div>

      </div>


      {/* dashboard baris 2 */}
      <div className='flex lg:flex-row flex-col gap-2 w-full my-8'>

        {/* total transaksi */}
        <div className='flex flex-col gap-8 lg:w-1/2 border border-gray-300 rounded-lg px-4 py-4'>

          <div className='flex mb-1 justify-between'>
            <div>
              <p className='text-[11px] font-semibold text-gray-800'>Total Transaksi</p>
              <p className='mt-3 font-bold text-gray-800'>
                <span className='text-sm'>Rp</span>
                <span className='text-2xl ml-0.5'>24.550.000</span>
              </p>
            </div>

          </div>


          <div className='grid grid-cols-3 '>
            <div className='flex flex-col'>
              <p className='flex text-[11px] font-base text-gray-800'>Sampai Tanggal</p>
              <p className='flex font-bold text-gray-800'>
                <span className='text-[11px]'>31 Mei 2023</span>
              </p>
            </div>

            <div className='flex gap-2'>
              <img src='/ic-transaction-up.svg' className='flex w-[42px]' />
              <div className='flex flex-col'>
                <p className='text-[11px] font-bold text-gray-800'>Naik 5%</p>
                <p className='font-base text-gray-800'>
                  <span className='text-[11px]'>dari bulan lalu</span>
                </p>
              </div>
            </div>

            <div className='flex gap-2'>
              <img src='/ic-transaction-down.svg' className='flex w-[42px]' />
              <div className='flex flex-col'>
                <p className='text-[11px] font-base text-gray-800'>Bulan Lalu</p>
                <p className='font-bold text-gray-800'>
                  <span className='text-[11px]'>Rp. 15.120.000</span>
                </p>
              </div>
            </div>

          </div>

          <div className="flex-grow border-t border-gray-300"/>


          <div className=' grid grid-cols-2'>

            <div className='flex gap-2 items-center '>
              <div className='bg-[#87c816] flex h-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]'>
                LUNAS
              </div>
              <p className=' font-semibold text-gray-800'>
                <span className='text-xs'>Rp</span>
                <span className='text-md ml-0.5'>4.550.000</span>
              </p>
            </div>

            <div className='flex gap-2 items-center '>
              <div className='bg-[#ca4e4e] flex h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                CANCEL
              </div>
              <p className=' font-semibold text-gray-800'>
                <span className='text-xs'>Rp</span>
                <span className='text-md ml-0.5'>14.000.000</span>
              </p>
            </div>

          </div>

        </div>
        {/* graph  */}
        <div className=' lg:w-1/2 border border-gray-300 rounded-lg py-2'>

          <TransactionChart />

        </div>

      </div>


      {/* transaction table  */}

      <TransactionReport />

    </div >
  );
}

export default Dashboard;